
export default function AssessmentFactorController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  userService,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.ECAT;
  vm.isExpanded = false;


  // Attach Event Handlers
  vm.handleExpandAssessmentFactor = _handleExpandAssessmentFactor;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////


  function _activate() {
    return userService.getUserPermissionSet('ecat').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
  }

  function _handleExpandAssessmentFactor() {
    vm.isExpanded = !vm.isExpanded;
  }
}

AssessmentFactorController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'userService',
  'serviceIds'
];
